// src/utils/hudUtils.ts – minimal HUD helpers used by renderFirstSection

/**
 * Sets the HUD type for a section element based on its attributes.
 * @param el The section element to annotate
 * @param attrs The section attributes (from markdown frontmatter)
 */
export function setHudType(el: HTMLElement, attrs: Record<string, any>) {
  if (attrs["video-reel"]) {
    el.dataset.reel = "true";
    el.dataset.hudType = "reel";
  } else if (attrs.audio) {
    el.dataset.hudType = "narration";
  } else {
    el.dataset.hudType = "basic";
  }
}